export const SELL_STEP_1 = 1;
export const SELL_STEP_2 = 2;
export const SELL_STEP_3 = 3;
export const SELL_STEP_4 = 4;
export const SELL_STEP_5 = 5;
